var path = 'src/app/patients/aliases/aliases.html';
var html = "<h1 class=page-header>Aliases</h1> <div patient-aliases-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/aliases/aliases.html
 ** module id = 387
 ** module chunks = 0
 **/